import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../../../..';
import ApiaApi, {
  IApiaApiRequestConfig,
  makeApiaUrl,
} from '../../../../../api/apiaApi/apiaApi';
import { TApiaModalRefreshDataResponse } from '../../../../../components/apia/execution/fields/apiaFinder/types';
import { arrayOrArray } from '../../../../../utils/util';
import { buttonsActions } from '../../../../buttonsSlice';
import { TAsyncThunkState, TListRowsStructure } from '../../../types';
import { parseRows } from '../../util/rowsParser';
import { notify } from '../../../../../components/common/notifications/util';

export type TRefreshData = {
  listId: string;
  url?: string;
  requestConfig?: IApiaApiRequestConfig<unknown>;
  pageNumber?: number;
  queryData?: Record<string, unknown>;
  forceTabId?: boolean;
};

type TRefreshDataResponse = TApiaModalRefreshDataResponse;

const page = createAsyncThunk<
  TListRowsStructure,
  TRefreshData,
  TAsyncThunkState
>(
  'listSlice/page',
  async (
    { forceTabId = false, listId, requestConfig, url, pageNumber, queryData },
    thunkApi,
  ) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );
    const state = thunkApi.getState().listSlice.lists[listId];
    const filters = state.filters;

    /**
     * La siguiente logica se encarga de detecctar si todos los filtros
     * requeridos fueron ingresados. De ser asi o si no hay filtros requeridos,
     * isRequirementSet deberia cambiar a true
     */
    let isRequirementSet = false;
    let required = 0;
    let withValue = 0;

    if (filters) {
      state.filters?.forEach((innerFilter) => {
        if (
          !filters.find(
            (incommingfilter) => incommingfilter.id === innerFilter.id,
          )
        ) {
          if (innerFilter.required) {
            required++;
            if (innerFilter.currentValue) {
              withValue++;
            }
          }
        }
      });
      filters.forEach((innerFilter) => {
        if (innerFilter.required) {
          required++;
          if (innerFilter.currentValue) {
            withValue++;
          }
        }
      });
    }

    if (required === withValue) isRequirementSet = true;
    if (isRequirementSet) {
      const response = await ApiaApi.post<TRefreshDataResponse>(
        url ??
          makeApiaUrl({
            action: 'page',
            pageNumber: pageNumber ?? '',
            ajaxUrl: state.ajaxUrl,
            tabId: forceTabId ? state.tabId : undefined,
            react: true,
          }),
        { ...requestConfig, ...(queryData ? { queryData } : null) },
      );

      const pageInfo = response?.data?.function?.messages?.result?.pageInfo;
      const row = response?.data?.function?.messages?.result?.table?.row;

      store.dispatch(
        buttonsActions.updateAction([
          {
            performing: false,
            action: 'disableTable',
          },
        ]),
      );

      return {
        pageInfo: pageInfo ?? undefined,
        rows: parseRows(listId, (row && arrayOrArray(row)) || []),
      };
    } else {
      store.dispatch(
        buttonsActions.updateAction([
          {
            performing: false,
            action: 'disableTable',
          },
        ]),
      );
      notify({
        message: `${window.MSG_FILTER_REQUIRED}`,
        type: 'warning',
      });
      return {
        rows: [],
        pageInfo: undefined,
      };
    }
  },
);

export default page;
